<template>
  <div>
    <div class="ui top fixed secondary pointing menu smardie-top-nav">
      <div class="item img">
        <router-link to="/">
          <img :src="logoSrc" width="102px" height="22px" />
        </router-link>
      </div>

      <template v-if="showMainLinks">
        <router-link to="/" class="item"><i class="file text outline icon"></i>Quotes</router-link>
        <router-link to="/invoice" class="item"><i class="file dollar icon"></i>Invoices</router-link>
        <router-link to="/contact" class="item"><i class="address book outline icon"></i>Customers</router-link>
      </template>

      <router-link v-if="showMainLinks" :to="settingsLink" class="item">
        <i class="setting icon"></i>Settings
      </router-link>

      <div class="right menu" v-if="showAuthNav">
        <router-link v-if="!$store.getters['user/isPlatformAdmin'] && !mustUpgrade" to="/help" class="item">
          <i class="help icon"></i>
        </router-link>
        <a href="#" class="item smardie-nav-logout" v-on:click.prevent="logOut">
          <i class="logout icon"></i>
        </a>
      </div>
    </div>

    <div class="ui top fixed three item borderless menu smardie-mobile-top-nav">
      <div v-if="showMobileMenu" class="ui dropdown item" tabindex="0">
        <i class="list layout icon"></i>
        <div class="menu" tabindex="-1">
          <template v-if="!$store.getters['user/isPlatformAdmin']">
            <router-link to="/" class="item">Quotes</router-link>
            <router-link to="/invoice" class="item">Invoices</router-link>
            <router-link to="/contact" class="item">Customers</router-link>
          </template>
          <router-link :to="settingsLink" class="item">Settings</router-link>
          <router-link to="/help" class="item">Help</router-link>
          <a v-on:click="logOut"><div class="item">Logout</div></a>
        </div>
      </div>
      <a v-else-if="showUpgradeLogout" v-on:click="logOut" class="item"><i class="logout icon"></i></a>
      <div v-else class="item"></div>

      <div class="item">
        <router-link to="/"><img :src="logoSrc" width="102px" height="22px" /></router-link>
      </div>
      <div class="item"></div>
    </div>
  </div>
</template>

<script>
  import auth from '../../../helpers/auth'

  export default {
    data: function () {
      return {
        logoSrc: require('../../../assets/img/img_logo_text.png')
      }
    },
    computed: {
      isLoggedIn: function () {
        return this.$store.getters['user/isAuthenticated']
      },
      hasProfile: function () {
        return !!this.$store.getters['user/getProfile']
      },
      isPublicRoute: function () {
        return !(this.$route && this.$route.meta && this.$route.meta.requiresAuth === true)
      },
      /** When true, user has no active subscription and must select a plan; hide all nav except logo and logout */
      mustUpgrade: function () {
        const status = this.$store.getters['getSubscriptionStatus']
        return status && status.must_upgrade === true
      },
      showAuthNav: function () {
        // During bootstrap a stale token can set logged-in before profile probe finishes.
        // Keep app nav hidden until profile is loaded and never show it on public routes.
        return this.isLoggedIn && this.hasProfile && !this.isPublicRoute
      },
      showMainLinks: function () {
        return this.showAuthNav && !this.$store.getters['user/isPlatformAdmin'] && !this.mustUpgrade
      },
      showMobileMenu: function () {
        return this.showAuthNav && !this.$store.getters['user/isPlatformAdmin'] && !this.mustUpgrade
      },
      showUpgradeLogout: function () {
        return this.showAuthNav && this.mustUpgrade
      },
      settingsLink: function () {
        // Smardie platform admin → category (global) settings
        if (this.$store.getters['user/isPlatformAdmin'] === true) {
          return '/settings/category'
        }
        // Managers & workers → account settings entry point
        return '/settings/account'
      }
    },
    methods: {
      logOut: function () {
        auth.logout(this)
      }
    },
    updated: function () {
      $(this.$el).find('.ui.dropdown').dropdown()
    }
  }
</script>

<style scoped>
.ui.dropdown.item.text.disabled {
  color: var(--color-border) !important;
}

.smardie-top-nav {
  border-bottom: 1px solid rgba(40, 70, 100, 1) !important;
  background: var(--color-nav-bg) !important;
  height: 48px !important;
  z-index: 101 !important;
}

.smardie-top-nav .item,
.smardie-top-nav .item:link,
.smardie-top-nav .item:visited {
  color: #ffffff !important;
  display: flex !important;
  align-items: center !important;
  height: 48px !important;
  box-sizing: border-box;
}

.smardie-top-nav .item i.icon {
  color: #ffffff !important;
  height: auto !important;
  line-height: 1 !important;
  margin: 0 0.35em 0 0 !important;
  padding-top: 0 !important;
}

.smardie-top-nav .item:hover,
.smardie-top-nav .item:focus,
.smardie-top-nav .item:active {
  color: #4da1ff !important;
}

.smardie-top-nav .item:hover i.icon,
.smardie-top-nav .item:focus i.icon,
.smardie-top-nav .item:active i.icon {
  color: #4da1ff !important;
}

.smardie-top-nav .item.img {
  display: flex;
  align-items: center;
}

.smardie-top-nav .item.img img {
  display: block;
}

.smardie-mobile-top-nav {
  display: none !important;
}

@media screen and (max-width: 767px) {
  .smardie-top-nav {
    display: none !important;
  }

  .smardie-mobile-top-nav {
    display: flex !important;
    background-color: var(--color-nav-bg) !important;
    height: 48px !important;
    z-index: 101 !important;
    border: none !important;
    box-shadow: none !important;
  }

  /* Top bar (hamburger / logo / upgrade-logout) sits on the dark blue nav → white */
  .smardie-mobile-top-nav > .item,
  .smardie-mobile-top-nav > .item i.icon {
    color: var(--color-white) !important;
  }

  /* Open sheet: inherit theme text token (light → dark grey, dark → white).
     Do NOT hardcode dark-grey — it beats dark-mode white via scoped !important. */
  .smardie-mobile-top-nav .dropdown .menu {
    background: var(--color-bg-surface) !important;
    border: none !important;
    border-bottom: 1px solid var(--color-border) !important;
    box-shadow: none !important;
  }

  .smardie-mobile-top-nav .dropdown .menu .item,
  .smardie-mobile-top-nav .dropdown .menu a.item,
  .smardie-mobile-top-nav .dropdown .menu a,
  .smardie-mobile-top-nav .dropdown .menu a .item {
    color: var(--color-text) !important;
    -webkit-text-fill-color: var(--color-text) !important;
    text-align: center !important;
    justify-content: center !important;
  }

  .smardie-mobile-top-nav .dropdown .menu .item i.icon {
    color: var(--color-text) !important;
  }

  .smardie-mobile-top-nav .dropdown .menu .item:hover,
  .smardie-mobile-top-nav .dropdown .menu .item:active,
  .smardie-mobile-top-nav .dropdown .menu a:hover,
  .smardie-mobile-top-nav .dropdown .menu a:hover .item,
  .smardie-mobile-top-nav .dropdown .menu .router-link-active,
  .smardie-mobile-top-nav .dropdown .menu .router-link-exact-active {
    color: var(--color-primary) !important;
    -webkit-text-fill-color: var(--color-primary) !important;
  }
}
</style>
